module.exports = __webpack_public_path__ + "static/media/UniNeueThin-Italic.dd740a1f.ttf";